// Which page-change lock a page window uses (Insert, Delete, Replace), shipped dark 20 Oct 2026.
// A Vue mixin for the three page modals.
//
// - serverPageChange shows (lib/server-switches.js): the lock goes on at the click and comes off
//   through a transaction (lib/page-change-lock.js; the modal's own lockForPageChange and
//   releaseLockAfterChange), as tested on sandbox from 14 Oct.
// - Every other show: today's lock, unchanged. It goes on when the window opens and comes off when
//   the window closes or the change ends; a failed save leaves it as today.
//
// The mode is fixed when the window opens (beginPageChangeWindow), so the lock that comes off is
// always the kind that went on.
import { usesServerPageChange } from './server-switches.js'; // eslint-disable-line import/extensions

export default {
    data() {
        return { lockAtClick: false };
    },
    methods: {
        // When the page window opens. Returns today's lock write (callers await it or not, as before).
        beginPageChangeWindow() {
            this.lockAtClick = usesServerPageChange(this.project);
            if (this.lockAtClick) return Promise.resolve();
            this.$store.dispatch('projectBannerUser', { userid: this.user.uid });
            return this.$store.dispatch('projectBannerDisplay', { projectBannerDisplay: true });
        },
        // The window closes, is cancelled or starts over without a change.
        endPageChangeWindow() {
            if (this.lockAtClick) {
                if (!this.pageChangeRunning && !this.lockStaysUp) this.$store.dispatch('releasePageChangeLock');
                return Promise.resolve();
            }
            this.$store.dispatch('projectBannerUser', { userid: '' });
            return this.$store.dispatch('projectBannerDisplay', { projectBannerDisplay: false });
        },
        // Save & Continue or Proceed Without Saving was clicked. false = do not start.
        async startPageChange() {
            if (this.lockAtClick) return this.lockForPageChange();
            this.$store.dispatch('setLoader', { type: true });
            return true;
        },
        // The change has run.
        finishPageChange() {
            if (this.lockAtClick) return this.releaseLockAfterChange();
            this.$store.dispatch('projectBannerUser', { userid: '' });
            return this.$store.dispatch('projectBannerDisplay', { projectBannerDisplay: false });
        },
        // The save copy failed; the window stays open with Proceed Without Saving.
        afterFailedSave() {
            if (this.lockAtClick) return this.releaseLockAfterChange();
            return Promise.resolve();
        }
    }
};


// WEBPACK FOOTER //
// ./src/lib/page-change-lock-mode.js